// extracted by mini-css-extract-plugin
module.exports = {"transitionDefault":"Button-module--transition-default--2WriX","container":"Button-module--container--Jx57-","light":"Button-module--light--EyB1s"};